<template>
    <!-- Nueva tarjeta: formulario por secciones (1 Empresa · 2 Persona de contacto ·
         3 En el tablero · 4 Primera nota) + a la derecha cómo va a quedar la
         tarjeta y qué le falta. Solo "Empresa" es obligatoria. Queda cargada
         por el admin logueado. -->
    <CrmModal :titulo="crm.t('new.t')" :sub="crm.t('new.sub', { n: crm.nombreDe(crm.yo) })" :mw="1040" @cerrar="$emit('cerrar')">
        <div class="cr-nv">
            <div class="cr-nv-main">
                <p class="cr-note cr-nv-lead"><span v-html="I.info"></span><span>{{ crm.t('new.lead') }}</span></p>

                <CrmCampos ref="campos" v-model="form" :errores="errores" pref="nv" numerar @enter="crear">
                    <template #tras-empresa>
                        <p v-if="dup" class="cr-note cr-note--warn cr-nv-dup">
                            <span v-html="I.warn"></span>
                            <span>{{ crm.t('new.dup', { n: dup.empresa, e: crm.estado(dup.estado).nombre }) }}</span>
                            <button type="button" class="cr-btn-link" @click="verDup">{{ crm.t('new.dup_open') }}</button>
                        </p>
                    </template>

                    <!-- 3 · En el tablero -->
                    <section class="cr-sec" aria-labelledby="nv-g-tablero">
                        <header class="cr-sec-h">
                            <span class="cr-sec-n is-done" aria-hidden="true">3</span>
                            <div class="cr-sec-tt"><h4 id="nv-g-tablero">{{ crm.t('sec.tablero') }}</h4><p>{{ crm.t('sec.tablero_p') }}</p></div>
                            <span class="cr-sec-st is-ok">{{ crm.t('sec.done') }}</span>
                        </header>
                        <div class="cr-form">
                            <div class="cr-fld">
                                <span id="nv-l-estado" class="cr-fld-l"><span class="cr-fld-ic" aria-hidden="true" v-html="I.board"></span>{{ crm.t('p.state') }}</span>
                                <button type="button" class="cr-fld-dd" aria-haspopup="listbox" aria-expanded="false" aria-labelledby="nv-l-estado" @click="dd($event, 'estado')"><span v-html="crm.estPill(estado)"></span><span class="cr-chev" v-html="I.chev"></span></button>
                                <span class="cr-hint">{{ crm.t('new.state_h') }}</span>
                            </div>
                            <div class="cr-fld">
                                <span id="nv-l-asig" class="cr-fld-l"><span class="cr-fld-ic" aria-hidden="true" v-html="I.user"></span>{{ crm.t('p.asig') }}</span>
                                <button type="button" class="cr-fld-dd" aria-haspopup="listbox" aria-expanded="false" aria-labelledby="nv-l-asig" @click="dd($event, 'asig')"><span v-html="crm.whoHTML(asignado)"></span><span class="cr-chev" v-html="I.chev"></span></button>
                                <span class="cr-hint">
                                    <button v-if="asignado !== crm.yo" type="button" class="cr-btn-link" @click="asignado = crm.yo">{{ crm.t('new.mine') }}</button>
                                    <template v-else>{{ crm.t('new.asig_h') }}</template>
                                </span>
                            </div>
                            <div class="cr-fld">
                                <span id="nv-l-pri" class="cr-fld-l"><span class="cr-fld-ic" aria-hidden="true" v-html="I.flag"></span>{{ crm.t('p.pri') }}</span>
                                <div class="cr-nv-pri" role="radiogroup" aria-labelledby="nv-l-pri" @keydown="teclaPri">
                                    <button v-for="k in PRIS" :key="k || 'none'" type="button" role="radio" class="cr-nv-pri-b" :class="'is-' + (k || 'none')"
                                            :aria-checked="String(pri === k)" :tabindex="pri === k ? 0 : -1" @click="pri = k" v-html="crm.priPill(k)"></button>
                                </div>
                                <span class="cr-hint">{{ crm.t('new.pri_h') }}</span>
                            </div>
                            <div class="cr-fld">
                                <label for="nv-seg" class="cr-fld-l"><span class="cr-fld-ic" aria-hidden="true" v-html="I.cal"></span>{{ crm.t('p.follow') }}</label>
                                <div class="cr-nv-seg">
                                    <input id="nv-seg" v-model="seguimiento" type="date" class="cr-date-in" :min="hoy" aria-describedby="nv-seg-h" />
                                    <button v-for="r in RAPIDOS" :key="r.d" type="button" class="cr-chip cr-chip--xs" :aria-pressed="String(seguimiento === enDias(r.d))" @click="seguimiento = enDias(r.d)">{{ r.t }}</button>
                                    <button v-if="seguimiento" type="button" class="cr-btn-link" @click="seguimiento = ''">{{ crm.t('new.follow_clear') }}</button>
                                </div>
                                <span id="nv-seg-h" class="cr-hint">{{ crm.t('new.follow_h') }}</span>
                            </div>
                        </div>
                    </section>

                    <!-- 4 · Primera nota (opcional) -->
                    <section class="cr-sec" aria-labelledby="nv-g-nota">
                        <header class="cr-sec-h">
                            <span class="cr-sec-n" :class="{ 'is-done': nota.trim() }" aria-hidden="true">4</span>
                            <div class="cr-sec-tt"><h4 id="nv-g-nota">{{ crm.t('sec.nota') }}</h4><p>{{ crm.t('sec.nota_p') }}</p></div>
                            <span class="cr-sec-st">{{ crm.t('sec.optional') }}</span>
                        </header>
                        <div class="cr-fld">
                            <label for="nv-nota" class="cr-sr">{{ crm.t('sec.nota') }}</label>
                            <textarea id="nv-nota" v-model="nota" maxlength="2000" rows="3" :placeholder="crm.t('new.note_ph')" @keydown.ctrl.enter.prevent="crear" @keydown.meta.enter.prevent="crear"></textarea>
                            <span class="cr-hint cr-nv-cnt">{{ crm.t('hist.hint') }} · {{ crm.t('new.note_n', { n: nota.length }) }}</span>
                        </div>
                    </section>
                </CrmCampos>
            </div>

            <!-- Vista previa + lo que falta -->
            <aside class="cr-nv-side" :aria-label="crm.t('new.prev')">
                <div class="cr-nv-sticky">
                    <h4 class="cr-nv-h">{{ crm.t('new.prev') }}</h4>
                    <div class="cr-nv-col" :class="'tn-' + est.tn">
                        <span class="cr-nv-col-h"><span class="cr-dot"></span>{{ est.nombre }}<small>· {{ crm.t('new.prev_top') }}</small></span>
                        <article class="cr-cd cr-cd--prev" aria-hidden="true">
                            <div class="cr-cd-top">
                                <span v-html="crm.priPill(pri)"></span>
                                <span v-if="seguimiento" class="cr-cd-follow"><span v-html="I.flag"></span>{{ fechaCorta(seguimiento) }}</span>
                                <span class="cr-cd-sp"></span>
                                <span v-if="asignado" v-html="crm.avHTML(asignado, 'cr-av--s')"></span>
                            </div>
                            <h3 class="cr-cd-name" :class="{ 'is-ph': !v.empresa }">{{ v.empresa || crm.t('new.prev_name') }}</h3>
                            <p v-if="v.tipo" class="cr-cd-type">{{ v.tipo }}</p>
                            <div v-if="v.ciudades" class="cr-cd-row"><span v-html="I.pin"></span><span>{{ v.ciudades }}</span></div>
                            <div class="cr-cd-row"><span v-html="I.user"></span>
                                <span v-if="v.contacto">{{ v.contacto }}<span v-if="v.cargo" class="cr-muted"> · {{ v.cargo }}</span></span>
                                <span v-else class="cr-muted">{{ crm.t('card.no_contact') }}</span>
                            </div>
                            <div class="cr-cd-links">
                                <span v-for="l in enlaces" :key="l.k" class="cr-lk" :class="[l.cls, { 'cr-lk--off': !l.on }]" v-html="l.ic"></span>
                            </div>
                            <div class="cr-cd-foot">
                                <span v-html="crm.avHTML(crm.yo, 'cr-av--s')"></span>
                                <span>{{ crm.t('card.loaded_by') }} <b>{{ crm.nombreDe(crm.yo) }}</b> · {{ crm.t('rel.now') }}</span>
                            </div>
                        </article>
                    </div>

                    <h4 class="cr-nv-h">{{ crm.t('new.check') }}</h4>
                    <ul class="cr-nv-ck">
                        <li v-for="c in checklist" :key="c.k" :class="{ 'is-on': c.on, 'is-req': c.req && !c.on }">
                            <span class="cr-nv-ck-i" v-html="c.on ? I.check : c.req ? I.warn : ''"></span>
                            <button v-if="c.campo && !c.on" type="button" class="cr-nv-ck-b" @click="$refs.campos.enfocar(c.campo)">{{ c.t }}</button>
                            <span v-else>{{ c.t }}</span>
                            <span v-if="c.req" class="cr-req">{{ crm.t('sec.req') }}</span>
                        </li>
                    </ul>
                </div>
            </aside>
        </div>

        <template #pie>
            <small class="cr-nv-foot" :class="{ 'is-warn': !v.empresa }">
                <span v-html="v.empresa ? I.check : I.warn"></span>
                {{ v.empresa ? crm.t('new.foot_ok', { e: est.nombre }) : crm.t('new.foot_missing') }}
            </small>
            <button type="button" class="cr-btn cr-btn-ghost" @click="$emit('cerrar')">{{ crm.t('cancel') }}</button>
            <button type="button" class="cr-btn cr-btn-main" :disabled="enviando" @click="crear"><span v-html="I.plus"></span>{{ enviando ? crm.t('saving') : crm.t('new.go') }}</button>
        </template>
    </CrmModal>
</template>

<script>
import CrmModal from './CrmModal.vue';
import CrmCampos, { CAMPOS, validar, erroresApi } from './CrmCampos.vue';
import { I, norm, urlOk } from './crmUtil';

const PRIS = ['alta', 'media', 'baja', ''];
const iso = d => `${d.getFullYear()}-${String(d.getMonth() + 1).padStart(2, '0')}-${String(d.getDate()).padStart(2, '0')}`;

export default {
    name: 'CrmNueva',
    components: { CrmModal, CrmCampos },
    inject: ['crm'],
    props: { estadoInicial: { type: Number, default: null } },
    data() {
        const form = {}; CAMPOS.forEach(f => { form[f.k] = ''; });
        const pend = this.crm.estados.find(e => e.pend) || this.crm.estados[0];
        return {
            I, PRIS, form, errores: {},
            estado: this.estadoInicial || (pend && pend.id), pri: 'media', asignado: this.crm.yo,
            seguimiento: '', nota: '', enviando: false,
            RAPIDOS: [1, 3, 7].map(d => ({ d, t: this.crm.t('new.in_' + d) })),
        };
    },
    computed: {
        /** Valores sin espacios de más (para la vista previa y la lista). */
        v() { const o = {}; CAMPOS.forEach(f => { o[f.k] = String(this.form[f.k] || '').trim(); }); return o; },
        est() { return this.crm.estado(this.estado); },
        hoy() { return iso(new Date(this.crm.ahora)); },
        dup() { const n = norm(this.form.empresa); return n ? this.crm.tarjetas.find(t => norm(t.empresa) === n) : null; },
        enlaces() {
            const v = this.v, t = this.crm.t;
            return [
                { k: 'w', on: !!urlOk(v.web), ic: I.web, t: t('fld.web') },
                { k: 'm', on: !!v.email, ic: I.mail, t: t('fld.email') },
                { k: 'p', on: !!urlOk(v.liP), ic: I.in, cls: 'cr-lk--in' },
                { k: 'e', on: !!urlOk(v.liE), ic: I.in, cls: 'cr-lk--in' },
            ];
        },
        checklist() {
            const v = this.v, t = k => this.crm.t('new.ck.' + k);
            return [
                { k: 'empresa', t: t('empresa'), on: !!v.empresa, req: true, campo: 'empresa' },
                { k: 'datos', t: t('datos'), on: !!(v.tipo || v.ciudades || v.web), campo: 'tipo' },
                { k: 'persona', t: t('persona'), on: !!v.contacto, campo: 'contacto' },
                { k: 'via', t: t('via'), on: !!(v.email || v.liP || v.liE), campo: 'email' },
                { k: 'asig', t: t('asig'), on: !!this.asignado },
            ];
        },
    },
    methods: {
        enDias(n) { const d = new Date(this.crm.ahora); d.setDate(d.getDate() + n); return iso(d); },
        fechaCorta(d) { const [y, m, dd] = d.split('-').map(Number); return new Date(y, m - 1, dd).toLocaleDateString(this.crm.loc, { day: 'numeric', month: 'short' }); },
        dd(ev, campo) {
            const a = ev.currentTarget, crm = this.crm;
            if (crm.popAbierto(a)) return crm.cerrarPop();
            if (campo === 'estado') {
                crm.abrirPop({ anchor: a, titulo: crm.t('p.state'), w: 250, val: this.estado, items: crm.estados.map(e => ({ v: e.id, t: e.nombre, html: crm.estPill(e.id) })), onPick: v => { this.estado = v; } });
            } else {
                const items = [{ v: null, t: crm.t('f.nobody'), html: crm.whoHTML(null) }].concat(crm.brokers.map(b => ({ v: b.id, t: b.nombre, html: crm.whoHTML(b.id) })));
                crm.abrirPop({ anchor: a, titulo: crm.t('p.asig'), w: 260, buscar: items.length > 8, val: this.asignado || null, items, onPick: v => { this.asignado = v ? Number(v) : null; } });
            }
        },
        /** Flechas dentro del grupo de prioridad (como un radio). */
        teclaPri(e) {
            const d = { ArrowRight: 1, ArrowDown: 1, ArrowLeft: -1, ArrowUp: -1 }[e.key];
            if (!d) return;
            e.preventDefault();
            this.pri = PRIS[(PRIS.indexOf(this.pri) + d + PRIS.length) % PRIS.length];
            this.$nextTick(() => { const b = this.$el.querySelector('.cr-nv-pri-b[aria-checked="true"]'); if (b) b.focus(); });
        },
        verDup() { const id = this.dup.id; this.$emit('cerrar'); this.$nextTick(() => this.crm.abrir(id)); },
        async crear() {
            this.errores = validar(this.form);
            if (Object.keys(this.errores).length) { this.$refs.campos.enfocar(Object.keys(this.errores)[0]); return; }
            if (this.enviando) return;
            this.enviando = true;
            const datos = { estado_id: this.estado, prioridad: this.pri || null, asignado_id: this.asignado || null, seguimiento: this.seguimiento || null, nota: this.nota.trim() || null };
            CAMPOS.forEach(f => { datos[f.k] = this.v[f.k]; });
            try { await this.crm.crear(datos); this.$emit('cerrar'); }
            catch (e) { const api = erroresApi(e); if (api) { this.errores = api; this.$refs.campos.enfocar(Object.keys(api)[0]); } else this.crm.fallo(e); }
            this.enviando = false;
        },
    },
};
</script>
